import { useTranslation } from 'react-i18next';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { useNotification } from '@/js/libs/ui/src/V2';
import { useImpersonateUser } from '@/js/libs/use-auth';

type RevertImpersonation = (userEmail: string) => void;

const IMPERSONATION_REVERTED_TOAST_ID = 'impersonation-reverted';

// Ends the impersonation of the given user, returning the admin to their own identity, and warns them. The warning
// shows once however many requests of the impersonation fail together.
export const useRevertImpersonation = (): RevertImpersonation => {
  const [t] = useTranslation();
  const notify = useNotification();
  const impersonateUser = useImpersonateUser();

  return useCallbackRef<RevertImpersonation>((userEmail) => {
    impersonateUser(null);
    notify.warn({ body: t('messages:IMPERSONATION_REVERTED', { userEmail }), toastId: IMPERSONATION_REVERTED_TOAST_ID });
  });
};
